import API_URLS from "@/constants/apiUrls";
import { HTTP_METHODS } from "@/constants/httpMethods";
import { request } from "@/lib/api";

/**
 * Bus City Service
 * Şehir bazlı otobüs API'leri için servis
 */
export const busCityService = {
  /**
   * Şehrin en ucuz rotalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCheapestRoutes: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getCheapestRoutes,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir bilgilerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCityInfo: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getCityInfo,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehrin popüler firmalarını getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul"
   * }
   */
  getPopularCompanies: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getPopularCompanies,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehrin otobüs terminallerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.Slug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   *
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "Slug": "istanbul"
   * }
   */
  getBusStations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getBusStations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Popüler şehirleri getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr"
   * }
   */
  getPopulars: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getPopulars,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Arama popülerlerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.languageCode - Dil kodu (örn: "tr", "en")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "languageCode": "tr"
   * }
   */
  getSearchPopulars: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getSearchPopulars,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir hakkında bilgileri getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCityAbout: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getCityAbout,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehir sık sorulan sorularını getir
   * @param {Object} payload - API payload
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "CitySlug": "istanbul",
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getCitySss: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getCitySss,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehrin ortalama seyahat sürelerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "hatay", "istanbul")
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "CitySlug": "hatay",
   *   "LanguageCode": "tr",
   *   "CurrencyCode": "TRY"
   * }
   */
  getAverageTravelDurations: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getAverageTravelDurations,
      payload,
      headers,
      hasErrorHandler,
    }),

  /**
   * Şehrin diğer seyahat seçeneklerini getir
   * @param {Object} payload - API payload
   * @param {string} payload.LanguageCode - Dil kodu (örn: "tr", "en")
   * @param {string} payload.CitySlug - Şehir slug'ı (örn: "istanbul", "ankara")
   * @param {string} payload.CurrencyCode - Para birimi kodu (örn: "TRY", "USD")
   * @param {Object} headers - HTTP headers
   * @param {boolean} hasErrorHandler - Hata yönetimi aktif mi
   * @returns {Promise} API response
   * 
   * Payload Example:
   * {
   *   "LanguageCode": "tr",
   *   "CitySlug": "istanbul",
   *   "CurrencyCode": "TRY"
   * }
   */
  getOtherTravelOptions: (payload = {}, headers = {}, hasErrorHandler = false) =>
    request({
      method: HTTP_METHODS.POST,
      url: API_URLS.bus.city.getOtherTravelOptions,
      payload,
      headers,
      hasErrorHandler,
    }),
};
